export const USER_CATEGORY_COOKIE_NAME = "user-category"

export type UserCategoryType = "layman" | "professional"
